/**
 * Conversation domain — Branded ID types
 */
import { Schema } from "effect";

export const ConversationId = Schema.String.pipe(
  Schema.brand("ConversationId")
);
export type ConversationId = typeof ConversationId.Type;
